import React from 'react'
import PropTypes from 'prop-types'

const DocumentLocation = ({ documentLocation, title, ...props }) => {
  return (
    <a
      href={documentLocation}
      target="_blank"
      rel="noopener noreferrer"
      {...props}
    >
      {title}
    </a>
  )
}

DocumentLocation.propTypes = {
  documentLocation: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  props: PropTypes.object,
}

export default DocumentLocation
